// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__mMGw9","gfeWrapper":"CalendarEvent_gfeWrapper__3GKaz"};